// extracted by mini-css-extract-plugin
export var active = "_mk-2";
export var recordingDot = "_mk-1";
export var recordingIndicator = "_mk-0";